
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.047 8a4 4 0 100-8 4 4 0 000 8zM9.278 9H9.8c2.319 0 4.2 1.881 4.2 4.2v1.3a1.5 1.5 0 01-1.5 1.5h-11A1.5 1.5 0 010 14.5v-1.3C0 10.881 1.881 9 4.2 9h.522a5.446 5.446 0 004.556 0z","fill":"#348EF6"}})])
          )
        }
      }
    